import { createContext, useContext, useEffect, useRef, useState } from "react";

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const modalCloseRef = useRef(null);
  const lastFocusRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = menuOpen || bookingOpen ? "hidden" : "";
    if (bookingOpen) {
      lastFocusRef.current = document.activeElement;
      setTimeout(() => modalCloseRef.current?.focus(), 40);
    } else if (lastFocusRef.current) {
      lastFocusRef.current.focus?.();
    }
    const onKey = (e) => {
      if (e.key === "Escape") {
        setMenuOpen(false);
        setBookingOpen(false);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
    };
  }, [menuOpen, bookingOpen]);

  const openBooking = (e) => {
    e?.preventDefault();
    setBookingOpen(true);
    setMenuOpen(false);
  };
  const closeBooking = () => setBookingOpen(false);

  return (
    <BookingContext.Provider value={{ bookingOpen, openBooking, closeBooking, menuOpen, setMenuOpen, modalCloseRef }}>
      {children}
    </BookingContext.Provider>
  );
}

export function useBooking() {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used within BookingProvider");
  return ctx;
}
